import * as React from 'react'
import { BaseOverviewHeaderItemProps, useOverviewStyles } from '../../../pages/BaseOverview/BaseOverview'
import MoneyText from '../../../components/Text/Currency/MoneyText'
import {
    BaseDisbursementOverviewProps,
    DisbursementFilterType,
    DisbursementOverviewCount,
    DisbursementSortingType,
    ExtendedDisbursementOverviewDto,
    useItemStyles,
} from './BaseDisbursementOverview'
import { useSettings } from '../../../hooks/useSettings'
import useCurrencies from '../../../hooks/useCurrencies'
import { Checkbox, Tooltip } from '@fluentui/react-components'
import { useTranslation } from 'react-i18next'
import BaseOverviewCountBadge from '../../../pages/BaseOverview/BaseOverviewCountBadge'

export default function DisbursementHeaderItem(
    props: BaseOverviewHeaderItemProps<ExtendedDisbursementOverviewDto, DisbursementFilterType, DisbursementSortingType, DisbursementOverviewCount>,
) {
    const disbursementProps = props as unknown as BaseDisbursementOverviewProps
    const disbursementStyles = useItemStyles()
    const overviewStyles = useOverviewStyles()
    const { settings } = useSettings()
    const { t: translate } = useTranslation()
    const { getCurrency } = useCurrencies()

    if (props.viewportNarrow) {
        return (
            <>
                {props.onAllItemsSelected ? (
                    <>
                        <Checkbox
                            checked={props.isAllItemsSelected?.(props.items)}
                            disabled={!props.isAllItemsSelectable?.(props.items)}
                            onChange={(_, data) => props.onAllItemsSelected(data, props.items)}
                        />
                        <div></div>
                        <div></div>
                    </>
                ) : (
                    <BaseOverviewCountBadge {...props} />
                )}
                <div></div>
                <div></div>
                <div
                    className={
                        props.viewportTiny
                            ? disbursementStyles.listDisbursementItemTinyBottomRow
                            : disbursementStyles.listDisbursementItemSmallBottomRow
                    }
                >
                    <div></div>
                    <Tooltip relationship={'label'} content={translate('registration.rate')} withArrow>
                        <div>
                            {props.count.currencies?.map((currency, index) => (
                                <MoneyText key={index} amount={currency.turnover} currency={getCurrency(currency.currency)} align="right" />
                            ))}
                        </div>
                    </Tooltip>
                    {!props.viewportTiny && !disbursementProps.hideInvoiceField && (
                        <Tooltip relationship={'label'} content={translate('registration.turnover')} withArrow>
                            <div>
                                {props.count.currencies?.map((currency, index) => (
                                    <MoneyText
                                        key={index}
                                        amount={currency.invoiceTurnover}
                                        currency={getCurrency(currency.currency)}
                                        align="right"
                                    />
                                ))}
                            </div>
                        </Tooltip>
                    )}
                </div>
            </>
        )
    }

    return (
        <>
            {props.onAllItemsSelected ? (
                <>
                    <Checkbox
                        checked={props.isAllItemsSelected?.(props.items)}
                        disabled={!props.isAllItemsSelectable?.(props.items)}
                        onChange={(_, data) => props.onAllItemsSelected(data, props.items)}
                    />
                    <div></div>
                </>
            ) : (
                <BaseOverviewCountBadge {...props} />
            )}
            <div></div>
            <div></div>
            <div>
                <span className={overviewStyles.invisible}>
                    {settings?.fileReference?.prefix + ''.padEnd(settings?.fileReference?.length, '0') + settings?.fileReference?.suffix}
                </span>
            </div>
            <Tooltip relationship={'label'} content={translate('registration.rate')} withArrow>
                <div>
                    {props.count.currencies?.map((currency, index) => (
                        <MoneyText key={index} amount={currency.turnover} currency={getCurrency(currency.currency)} align="right" />
                    ))}
                </div>
            </Tooltip>
            {!disbursementProps.hideInvoiceField && (
                <Tooltip relationship={'label'} content={translate('registration.turnover')} withArrow>
                    <div>
                        {props.count.currencies?.map((currency, index) => (
                            <MoneyText key={index} amount={currency.invoiceTurnover} currency={getCurrency(currency.currency)} align="right" />
                        ))}
                    </div>
                </Tooltip>
            )}
        </>
    )
}
